import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_created",
  "use": "sort_created-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"sort_created\"><g fill-rule=\"evenodd\"><path d=\"M9.5 17a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z\" opacity=\".1\" /><path d=\"M9.5 16a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Zm0 1a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z\" /><path d=\"M9 5.5v4a.5.5 0 0 0 1 0v-4a.5.5 0 0 0-1 0Z\" /><path d=\"m9.146 9.854 2.536 2.535a.5.5 0 1 0 .707-.707L9.854 9.146a.5.5 0 1 0-.708.708Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol